import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 9 16"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.046.002H3.955v1.523a2.185 2.185 0 0 1 1.09 0V.002Zm-1.091 7.34V5.75a2.185 2.185 0 0 0 1.09 0v1.592a2.185 2.185 0 0 0-1.09 0Zm.545 4.293c.189 0 .371-.024.546-.068v2.49l2.364-2.102.724.815L4.5 16 .866 12.77l.725-.815 2.364 2.101v-2.49c.174.045.357.07.545.07Zm1.454-7.997a1.454 1.454 0 1 1-2.908 0 1.454 1.454 0 0 1 2.908 0Zm0 5.816a1.454 1.454 0 1 1-2.908 0 1.454 1.454 0 0 1 2.908 0Z",
      clipRule: "evenodd"
    }
  )
);
var SvgTimelineFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var TimelineFilled_default = SvgTimelineFilled;

export { TimelineFilled_default as default };
